module.exports = __webpack_public_path__ + "img/126ne.e366f68d.svg";